<template>
  <div>
    <div v-if="mode === 'DESIGN'">
      <el-date-picker
        size="medium"
        v-model="_value"
        disabled
        :editable="false"
        :type="type"
        :start-placeholder="placeholder[0]"
        :end-placeholder="placeholder[1]"
      />
      <div v-if="showLength" class="length">
        <span>时长：</span>
        <span>{{ timeLength }}</span>
      </div>
    </div>
    <div v-else>
      <el-date-picker
        v-model="_value"
        size="medium"
        :editable="false"
        clearable
        :value-format="format"
        :type="type"
        :start-placeholder="placeholder[0]"
        :end-placeholder="placeholder[1]"
        :disabled="r"
      />
      <div v-if="showLength" class="length">
        <span>时长：</span>
        <span>{{ timeLength }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import componentMinxins from "../ComponentMinxins";
import moment from "moment";

export default {
  mixins: [componentMinxins],
  name: "DateTimeRange",
  components: {},
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
    format: {
      type: String,
      default: "yyyy-MM-dd HH:mm",
    },
    placeholder: {
      type: Array,
      default: () => {
        return ["开始时间", "结束时间"];
      },
    },
    showLength: {
      type: Boolean,
      default: false,
    },
    config1: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    type() {
      switch (this.format) {
        case "yyyy-MM-dd":
          return "daterange";
        case "yyyy-MM-dd HH:mm":
          return "datetimerange";
        default:
          return "daterange";
      }
    },
    timeLength() {
      //求时长算法
      if (Array.isArray(this.value)) {
        let start = moment(this.value[0]).format(
          this.format.replaceAll("dd", "DD")
        );
        let end = moment(this.value[1]).format(
          this.format.replaceAll("dd", "DD")
        );
        if (start === end) {
          return "0 （时长为0，请确认）";
        }
        let mstart = moment(start);
        let mend = moment(end);
        let years = mend.diff(start, "years");
        let months = mend.diff(start, "months");
        let days = mend.diff(start, "days");
        let hours = mend.diff(start, "hours");
        let minutes = mend.diff(start, "minutes");
        minutes = minutes % 60;
        hours = hours % 24;
        months = months % 12;
        //因为每月天不固定，所以天要特殊动态处理
        if (mstart.date() < mend.date()) {
          days = mend.date() - mstart.date();
          if (minutes > 0 || hours > 0) {
            days--;
          }
        }
        //处理超过俩月且天超过31
        if (days > 31 && mend.month() - mstart.month() >= 2) {
          //将日期推至上月求差
          days = mend.diff(
            mstart.add(mend.month() - mstart.month() - 1, "month"),
            "days"
          );
        }
        return `${years > 0 ? years + "年 " : " "}${
          months > 0 ? months + "个月 " : " "
        }
                ${days > 0 ? days + "天 " : " "}${
          hours > 0 ? hours + "小时 " : " "
        }
                ${minutes > 0 ? minutes + "分钟 " : " "}`;
      } else {
        return "先选择时间哦";
      }
    },
  },
  data() {
    return { r: false };
  },
  mounted() {
    setTimeout(() => {
      if (this.config1) {
        if (
          this.config1.flag == 2 ||
          this.config1.flag == 3 ||
          this.config1.flag == 4
        ) {
          console.log("仅可读仅可读");
          this.r = true;
        } else {
          var perm = this.config1.perm;
          if (perm == "R") {
            this.r = true;
          }
        }
      }
    }, 500);
  },
  methods: {},
};
</script>

<style scoped>
.length {
  margin-top: 5px;
}
.length:nth-child(2) {
  color: #8c8c8c;
}
/deep/ .el-date-editor--datetimerange.el-input__inner {
  width: 100%;
  max-width: 400px;
}

/** 移动端展示 **/
@media screen and (max-width: 500px) {
  .el-picker-panel__sidebar {
    width: 100%;
  }
  .el-picker-panel {
    width: 400px !important;
  }
  .el-picker-panel__content {
    width: 100%;
  }
  .el-picker-panel__body {
    margin-left: 0 !important;
    display: flex;
    flex-direction: column;
    min-width: auto !important;
  }
  .el-picker-panel__sidebar {
    position: relative;
  }
  .el-picker-panel__body-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>
<style>
/* // 时间选择器移动端 适配begin */
@media (max-width: 768px) {
  .el-date-range-picker .el-picker-panel__body {
    min-width: 100%;
  }

  .el-date-range-picker__content {
    width: 100% !important;
  }

  .el-date-range-picker {
    width: 80% !important;
  }

  .el-date-range-picker__content {
    margin: 0px;
    padding: 5px;
  }

  .el-date-range-picker__content.is-left {
    padding-bottom: 0px;
  }

  .el-date-range-picker__content.is-right {
    padding-top: 0px;
  }

  .el-date-table th {
    padding: 0px;
  }

  .el-date-table td {
    padding: 0px;
  }
}
/* // 时间选择器移动端 适配end */
</style>
